export const en = {
    "activation-grammar": "Activation Grammar",
    "button-add-tests": "Add to tests",
    "button-delete": "Delete",
    "button-edit": "Edit",
    "button-get-requests": "Get requests",
    "button-save": "Save",
    "button-test": "Test it",
    "button-view": "View",
    "create-intent": "Create",
    "entities-subtitle": "Entities allow you to create reusable components for writing grammars.",
    "entities-title": "Entities",
    "error": "An error has occurred",
    "error-grammar": "Grammar error",
    "error-no-logs": "There are no logs for your grammar",
    "error-server-side": "Error on the server side",
    "header-settings": "Settings",
    "header-verstehen": "Mark the queries that fit your grammar:",
    "hint-add-tests": "The queries you have selected will be added to the positive and negative tests",
    "hint-grammar": "The grammar text. For more information, see [the documentation page]",
    "hint-id": "Unique Internet identifier",
    "hint-name": "Name to display in the console interface",
    "hint-negative-tests": "Phrases that the grammar should not work on",
    "hint-positive-tests": "Phrases that the grammar should work on",
    "intent-no-name": "Untitled",
    "intents-description": "Intents are needed to determine the user's intention based on the request and extract some parameters from the request. Read more about the intents on [the documentation page].",
    "intents-title": "Intents",
    "label-frequency": "Frequency",
    "label-proximity": "Proximity",
    "label-requests": "Requests",
    "parameters": "Parameters",
    "search-engine": "Semantic search",
    "test-result-completeness": "Completeness:",
    "test-result-negative": "Negative tests:",
    "test-result-occuracy": "Accuracy:",
    "test-result-positive": "Positive tests:",
    "title-grammar": "Grammar",
    "title-name": "Title",
    "title-negative-tests": "Negative tests",
    "title-positive-tests": "Positive tests",
    "title-result": "Test results",
    "tooltip-invalid-intent": "The intent is not filled in, or it is filled in incorrectly.\nSuch an intent will not be published.",
    "tooltip-new": "New",
    "tooltip-saved": "Saved",
    "tooltip-tested": "Tested",
    "warning-message": "You have unsaved changes, do you really want to continue?",
    "warning-title": "Attention",
    "validation-error": "Validation error",
    "entity-may-been-deleted-error": "An error occurred: the requested entity may have been deleted.",
    "size-exceed-error": "The size of the compiled grammar must not exceed 59,000 characters.",
    "changes-saved": "Changes saved",
    "no-more-than-500-lines-error": "No more than 500 lines in the grammar.",
    "not-all-required-fields-error": "Not all required fields are filled.",
    "intent-with-specified-id-error": "An intent with the specified ID already exists.",
    "intent-settings": "Intent configuration",
    "status-new": "new",
    "status-published": "published",
    "status-invalid": "incorrectly filled in"
} as const;
export const ru = {
    "activation-grammar": "Активационная грамматика",
    "button-add-tests": "Добавить в тесты",
    "button-delete": "Удалить",
    "button-edit": "Редактировать",
    "button-get-requests": "Собрать запросы",
    "button-save": "Сохранить",
    "button-test": "Протестировать",
    "button-view": "Просмотреть",
    "create-intent": "Создать",
    "entities-subtitle": "Сущности позволяют создавать переиспользуемые компоненты для написания грамматик.",
    "entities-title": "Сущности",
    "error": "Произошла ошибка",
    "error-grammar": "Ошибка в грамматике",
    "error-no-logs": "Нет логов для вашей грамматики",
    "error-server-side": "Ошибка на стороне сервера",
    "header-settings": "Настройки",
    "header-verstehen": "Отметьте запросы, которые подходят под вашу грамматику:",
    "hint-add-tests": "Выбранные вами запросы добавятся в положительные и отрицательные тесты",
    "hint-grammar": "Текст грамматики. Подробнее на [странице документации]",
    "hint-id": "Уникальный идентификатор интента",
    "hint-name": "Название для отображение в интерфейсе консоли",
    "hint-negative-tests": "Фразы, на которые не должна срабатывать грамматика",
    "hint-positive-tests": "Фразы, на которые должна срабатывать грамматика",
    "intent-no-name": "Без названия",
    "intents-description": "Интенты нужны для определения намерения пользователя на основании запроса и извлечения из запроса некоторых параметров. Подробнее об интентах читайте на [странице документации].",
    "intents-title": "Интенты",
    "label-frequency": "Частота",
    "label-proximity": "Близость",
    "label-requests": "Запросы",
    "parameters": "Параметры",
    "search-engine": "Семантический поиск",
    "test-result-completeness": "Полнота:",
    "test-result-negative": "Отрицательные тесты:",
    "test-result-occuracy": "Точность:",
    "test-result-positive": "Положительные тесты:",
    "title-grammar": "Грамматика",
    "title-name": "Название",
    "title-negative-tests": "Отрицательные тесты",
    "title-positive-tests": "Положительные тесты",
    "title-result": "Результаты тестирования",
    "tooltip-invalid-intent": "Интент не заполнен, или заполнен некорректно.\nТакой интент не будет опубликован.",
    "tooltip-new": "Новый",
    "tooltip-saved": "Сохранено",
    "tooltip-tested": "Протестировано",
    "warning-message": "У вас есть несохраненные изменения, вы действительно хотите продолжить?",
    "warning-title": "Внимание",
    "validation-error": "Ошибка при валидации",
    "entity-may-been-deleted-error": "Произошла ошибка: возможно, запрашиваемая сущность была удалена.",
    "size-exceed-error": "Размер скомпилированной грамматики не должен превышать 59 000 символов.",
    "changes-saved": "Изменения сохранены",
    "no-more-than-500-lines-error": "Не более 500 строк в грамматике",
    "not-all-required-fields-error": "Заполнены не все обязательные поля",
    "intent-with-specified-id-error": "Интент с указанным ID уже существует",
    "intent-settings": "Настройка интента",
    "status-new": "новый",
    "status-published": "опубликован",
    "status-invalid": "некорректно заполнен"
} as const;
